import { Component, OnInit, Inject, Input } from '@angular/core';
import { ConditionCommentModalComponent } from '../../../interpretation/components/condition-comment-modal/condition-comment-modal.component';
import { InterpretationService } from '../../../interpretation/interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../../../shared/services/user.service';
import { NewInspectionService } from '../../services/new-inspection.service';
import { GenericIdName } from './../../../../../app/shared/models/common-search-filters.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BogieCommentVM } from '../../../../shared/components/bogie-shim/bogie-shim-model';

@Component({
  selector: 'app-add-comment-on-component',
  templateUrl: './add-comment-on-component.component.html',
  styleUrls: ['./add-comment-on-component.component.scss']
})




export class AddCommentOnComponentComponent implements OnInit {
  private inspectionId: number;
  comment: string;
  savingComment = false;
  isInspector = true;
  isInterpreter = true;
  isViewMode: boolean = false;
  isInterp: boolean = false;


  equipmentId: number;
  inspectionDetailDraftId: number;
  constructor(
    private _dialogRef: MatDialogRef<ConditionCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
  private _user: UserService,
  private _inspectionService: NewInspectionService) {

  }

  ngOnInit() {
    this.checkPermissions();
    this.comment = this._data.comment;
    this.inspectionDetailDraftId = this._data.inspectionDetailDraftId;
    this.equipmentId = this._data.equipmentId;
    this.CompartTypeId= this._data.CompartTypeId;
    this.isViewMode=this._data.viewMode;
    this.isInterp=this._data.Interp;
    this.LoadCompartTypeComments();
  }

    onNoClick(): void {
    this._dialogRef.close(false);
  }
  checkPermissions() {
    // this._user.getUserJobRoles().subscribe(
    //   jobRoles => {
    //     jobRoles.forEach(role => {
    //       switch (role.Name) {
    //         case 'Inspectors':
    //           this.isInspector = true;
    //           break;
    //         case 'Interpreters':
    //         case 'Super User':
    //         case 'Administrator':
    //           this.isInterpreter = true;
    //           this.isInspector = true;
    //           break;
    //       }
    //     });
    //   },
    //   error => {
    //     console.error(error);
    //     this._notify.error('Error', 'Unable to check your job roles. ');
    //   }
    // );
  }

  updateComment(newComment: string) {
    if(!this.isInterp){
      this.comment = newComment;
      this._dialogRef.close(this.comment);
    } 
    else if(this.isInterp){
      var updateParams: BogieCommentVM = new BogieCommentVM();
          updateParams.BogieId= this._data.BogieId,
          updateParams.Comment= newComment
      this._interp.updateBogieComment(updateParams).subscribe(r => {
          console.log('r', r);
             if (r.m_Item1) {
        this._notify.success(r.m_Item2);
        this._dialogRef.close(newComment);
      }      else {
        this._notify.error(r.m_Item2);
      }
          });
    }
    else {
      this.savingComment = true;
    this._inspectionService.saveCommentOnComponentDetail(this.inspectionDetailDraftId, this.equipmentId , newComment).subscribe(r => {
      this.savingComment = false;
      if (r.m_Item1) {
        this._notify.success(r.m_Item2);
        this._dialogRef.close(r.m_Item1);
      }      else {
        this._notify.error(r.m_Item2);
      }
    });
    }
  }

  CompartTypeCommentList:GenericIdName[]=[];
  compartTypeComment:string;
  CompartTypeId:number;

  LoadCompartTypeComments(){
    this._inspectionService.GetComponentTypeComments(this.CompartTypeId ).subscribe(r => {
      this.CompartTypeCommentList=r;
    }, err => {
      this._notify.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }
  AddCompartTypeComment(){
    if(this.comment!=null && this.comment!=""){
      this.comment += "\n" + this.compartTypeComment;
    }else{
      this.comment=this.compartTypeComment;
    }
  }

}
